export default "__VITE_ASSET__D0qO9rwL__"